'use strict';
var React = require('react');
var BaseComponent = require('../../shared/base');

if (typeof window !== 'undefined') {
    var $ = window.$;
}

class SearchFilterComponent extends BaseComponent {
    constructor(props) {
        super(props);

        this.state = {
            minPrice: null,
            maxPrice: null,
            showCpls: [],
            selectedPrice: null
        }
    }

    componentDidMount() {
        if (typeof window !== 'undefined') {
            if ($(window).width() > 767) {
                $(window).on("scroll", function () {
                    var $getHeightFooter = $(".footer").innerHeight();
                    var $getHeightHeader = $(".header").innerHeight();
                    var $totalHeight = $getHeightFooter + $getHeightHeader;

                    var scrollHeight = $(document).height();
                    var scrollPosition = $(window).height() + $(window).scrollTop();

                    if ((scrollHeight - scrollPosition) / scrollHeight <= 0.05) {
                        $(".fsc-container.fsc-buttons").css("padding-bottom", "30px");
                        $(".fixed-sidebar .fs-scroll").addClass("bottom-scroll");
                        $(".fixed-sidebar .fs-scroll").css("bottom", $totalHeight + "px");
                        $(".fixed-sidebar .fs-scroll").css("position", "absolute");
                        $(".fixed-sidebar .fs-scroll > .fsc-container:first-child()").css("margin-top", $totalHeight + "px");
                    }
                    else {
                        $(".fsc-container.fsc-buttons").css("padding-top", "30px");
                        $(".fsc-container.fsc-buttons").css("padding-bottom", "135px");
                        $(".fixed-sidebar .fs-scroll").removeClass("bottom-scroll");
                        $(".fixed-sidebar .fs-scroll").css("bottom", "auto");
                        $(".fixed-sidebar .fs-scroll").css("position", "relative");
                        $(".fixed-sidebar .fs-scroll > .fsc-container:first-child()").css("margin-top", "auto");
                    }
                });
            }
        }

        var $filterWidth = $(".fs-content").innerWidth();
        $(".fs-content").css("margin-left", -$filterWidth + "px");

        var screenWidth = $(window).width();

        if(screenWidth > 1100){
            $(".fixed-sidebar").addClass("open");
            $(".fa-angle-down").addClass("hide");
            $(".search-container").addClass("open-sidebar");
        } else {
            $(".fa-angle-up").addClass("hide");
        }

        $('.fs-btn-slide').on('click', function () {
            if ($(".fixed-sidebar").hasClass("open")) {
                $(".fs-content").animate({ left: "0" }, "slow");
                $('.fs-btn-slide').animate({ left: "0" }, "slow");
                $(".open-sidebar").css("margin-left", "0");
                $(".search-container").removeClass("open-sidebar");
                $(".fs-btn-slide .fa-angle-up").addClass("hide");
                $(".fs-btn-slide .fa-angle-down").removeClass("hide");
                $(".fixed-sidebar").removeClass("open");
            }
            else if (!$(".fixed-sidebar").hasClass("open")) {
                $(".fs-content").animate({ left: $filterWidth + "px" }, "slow");
                $('.fs-btn-slide').animate({ left: $filterWidth + "px" }, "slow");
                $(".search-container").addClass("open-sidebar");
                $(".open-sidebar").css("margin-left", $filterWidth + "px");
                $(".fs-btn-slide .fa-angle-up").removeClass("hide");
                $(".fs-btn-slide .fa-angle-down").addClass("hide");
                $(".fixed-sidebar").addClass("open");
            }
        });

        if (this.props.totalRecords === 0) {
            $(".fs-content").animate({ left: "0" }, "slow");
            $('.fs-btn-slide').animate({ left: "0" }, "slow");
            $(".open-sidebar").css("margin-left", "0");
            $(".search-container").removeClass("open-sidebar");
            $(".fs-btn-slide .fa-angle-up").addClass("hide");
            $(".fs-btn-slide .fa-angle-down").removeClass("hide");
            $(".fixed-sidebar").removeClass("open");
        }

        $(".fs-content").niceScroll({
            cursorcolor: "#1C00ff00",
            zindex: "99999999",
            cursorwidth: "6px",
            cursorborderradius: "5px",
            cursorborder: "0px solid transparent",
            touchbehavior: true,
            preventmultitouchscrolling: true,
            enablekeyboard: true
        });

        $('.fs-scroll').niceScroll({
            cursorcolor: "#b3b3b3",
            zindex: "50",
            cursorwidth: "6px",
            cursorborderradius: "5px",
            cursorborder: "1px solid transparent",
            touchbehavior: true,
            autohidemode:false
        });
        

        var range_slider = $('.item-range').slider({
            precision: 2,
            range: true
        });
        range_slider.on("slide", function (slideEvt) {
            var i = slideEvt.value;
            var start = i[0];
            var end = i[1];
            $("#start").text(start);
            $("#end").text(end);
        });

        this.setState({showCpls: new Array(this.props.motors.length).fill(false)})

        this.setupPriceSlider();
        this.setSelectedCategory();
    }


    componentDidUpdate() {
        this.setSelectedCategory();
        this.setupPriceSlider();
    }

    setupPriceSlider() {
        let price = this.getMinMaxPrice();

        $('.item-range').slider({
            min: price.Minimum,
            max: price.Maximum,
            value: [price.Minimum, price.Maximum]
        });

        $('.item-range').slider('refresh');
       
        $('.filter-price-label').html(this.formatMoney(this.props.currencyCode) + ' ');
        $('.start-range').html(price.Minimum);
        $('.end-range').html(price.Maximum);
    }

    getPriceIntervals() {
        let arrPriceIntervals = [];

        if(this.props.totalRecords > 5){
            let min = Math.floor(this.props.priceRange.Minimum);
            let max = Math.ceil(this.props.priceRange.Maximum);

            let half = Math.round((max - min) / 2);
            let quart = Math.round((half - min) / 2);

            arrPriceIntervals = [min, quart, half, max];
        } else {
            arrPriceIntervals = null;
        }

        return(arrPriceIntervals);
    }

    getMinMaxPrice() {        
        if (this.props.priceRange) {
            return { ...this.props.priceRange };
        }
        let prices = this.props.itemPrices;
        if (prices.length === 0) {
            prices.push(0);
        }

        const minPrice = Math.min.apply(null, prices);
        const maxPrice = Math.max.apply(null, prices);

        return {
            Minimum: minPrice,
            Maximum: maxPrice
        };
    }

    getCustomFields(categoryIds, callback) {
        if (categoryIds && categoryIds.length > 0) {
            $.ajax({
                url: '/search/customfields',
                type: 'post',
                data: { categoryids: categoryIds },
                success: function (customfields) {
                    callback(customfields);
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    console.log(textStatus, errorThrown);
                }
            });
        }
    }

    setSelectedCategory() {
        if (this.props.selectedCategories) {
            $('.fsc-ul-cat ul').each(function (index, item) {
                var self = $(this);
                if (self.find('li.selected').length > 0) {
                    self.find('li.selected').first().removeClass('selected');
                }
            });

            Array.from(this.props.selectedCategories).map(function (category, index) {
                $('.category-anchor-trigger[data-id="' + category.ID + '"]').each(function (index, item) {
                    var self = $(this).first();
                    self.parent().closest('li').addClass('selected');
                    self.siblings('.st-subcat').show();
                    self.siblings('.st-subcat').css("opacity", "1");
                });

                $('.root-category[data-id="' + category.ID + '"]').each(function (index, item) {
                    var self = $(this).first();
                    self.parent().closest('li').addClass('selected');
                });

                $('.back[data-id="' + category.ID + '"]').each(function (index, item) {
                    $(this).addClass('selected');
                });

                $('ul.st-subcat').each(function (index, item) {
                    var self = $(this);
                    if (self.find('li.selected').length > 1) {
                        self.find('li.selected').first().removeClass('selected');   
                    } else if (self.parents('.selected').length == 0 && self.find('li').hasClass('selected') == false) {
                        self.hide();
                    }
                });

                
            });
        }

        $('.st-parent li').click(function(e) {
            $('.st-parent li').removeClass('selected');
            var $this = $(this);
            if (!$this.hasClass('selected')) {
                $this.addClass('selected');
            };
            e.preventDefault();
        });
    }

    renderParentCategories() {
        const self = this;
        return (
            Array.from(self.props.categories).map(function (category, index) {
                if (category.ID !== process.env.MARCA) {
                    const selected = self.props.selectedCategories ? self.props.selectedCategories.find(x => x.ID == category.ID) : null;

                    if (category.ChildCategories && category.ChildCategories.length > 0) {
                        return (
                            <li key={category.ID}>
                                    <div style={{display:"flex"}} className="parent-category" data-id={category.ID}>
                                        <label htmlFor={category.ID}>{category.Name}</label>
                                        {
                                            selected ? 
                                            <input checked style={{marginLeft:"5px"}} className="Search_filter_chkbox" type="checkbox" data-id={category.ID} value={category.ID} id={category.ID} name="categoria" readOnly/>
                                            :
                                            <input style={{marginLeft:"5px"}} className="Search_filter_chkbox" type="checkbox" data-id={category.ID} value={category.ID} id={category.ID} name="categoria" readOnly/>
                                        }
                                    </div>
                                    <ul style={{marginLeft:"15px"}}>
                                        {self.renderChildCategories(category, category.ChildCategories)}
                                    </ul>
                            </li>
                        );
                    } else {
                        return (
                            <li key={category.ID}>
                                <div style={{display:"flex"}} className="parent-category" data-id={category.ID}>
                                    <label htmlFor={category.ID}> {category.Name}</label>
                                    {
                                            selected ? 
                                            <input checked style={{marginLeft:"5px"}} className="Search_filter_chkbox" type="checkbox" data-id={category.ID} value={category.ID} id={category.ID} name="categoria" readOnly/>
                                            :
                                            <input style={{marginLeft:"5px"}} className="Search_filter_chkbox" type="checkbox" data-id={category.ID} value={category.ID} id={category.ID} name="categoria" readOnly/>
                                        }
                                </div>
                            </li>
                        );
                    }
                }
            }));
    }

    renderChildCategories(parentCategory, childCategories) {
        const self = this;
        return (
            Array.from(childCategories).map(function (category, index) {
                const selected = self.props.selectedCategories ? self.props.selectedCategories.find(x => (x.ID == category.ID || x.ID == category.ParentCategoryID)) : null;
                
                if (category.ChildCategories && category.ChildCategories.length > 0) {
                    return (
                        <li key={category.ID}>
                            <div style = {{display:"flex"}} className="parent-category" data-id={category.ID}>
                                <label htmlFor={category.ID}>{category.Name}</label>
                                {
                                    selected ? 
                                    <input checked style={{marginLeft:"5px"}} className="Search_filter_chkbox" type="checkbox" data-id={category.ID} value={category.ID} id={category.ID} name="categoria" readOnly/>
                                    :
                                    <input style={{marginLeft:"5px"}} className="Search_filter_chkbox" type="checkbox" data-id={category.ID} value={category.ID} id={category.ID} name="categoria" readOnly/>
                                }
                            </div>
                            <ul style={{marginLeft:"15px"}}>
                                {self.renderChildCategories(category, category.ChildCategories)}
                            </ul>
                        </li>
                    );
                } else {
                    return (
                        <li key={category.ID}>
                            <div style = {{display:"flex"}} className="parent-category" data-id={category.ID}>
                                <label htmlFor={category.ID}> {category.Name}</label>
                                {
                                    selected ? 
                                    <input checked style={{marginLeft:"5px"}} className="Search_filter_chkbox" type="checkbox" data-id={category.ID} value={category.ID} id={category.ID} name="categoria" readOnly/>
                                    :
                                    <input style={{marginLeft:"5px"}} className="Search_filter_chkbox" type="checkbox" data-id={category.ID} value={category.ID} id={category.ID} name="categoria" readOnly/>
                                }
                            </div>
                        </li>
                    );
                }
            }));
    }

    renderCustomFields() {
        if (this.props.customFilters && this.props.customFilters.length > 0) {
            return (
                Array.from(this.props.customFilters).map(function (customField, index) {
                    return (
                        <div className="fsc-container" key={customField.Code}>
                            <div className="fsc-field">
                                <span className="title">{customField.Name}</span>
                                <div className="fsc-filter-checkbox full-width">
                                    {Array.from(customField.Options).map(function (option, optIndex) {
                                        return (
                                            <span className="fancy-checkbox full-width" key={'option' + optIndex}>
                                                <label htmlFor={customField.Code + "_option_" + optIndex}>{option.Name}</label>
                                                <input type="checkbox" id={customField.Code + "_option_" + optIndex} name={customField.Code + "_custom-options[]"} className="custom-values-checkbox" data-id={customField.Code} data-name={option.Name} readOnly/>
                                            </span>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                    );
                }));
        }
    }

    renderMotorList(){
        const self = this;
        if(this.props.motors && this.props.motors.length > 0) {
            return(
                <div className="fsc-categories">
                    <span className="Search_title">Motores</span>
                    <div className="fsc-ul-cat">
                        <ul>
                            {   
                                self.props.motors.map(function (motor, index){
                                    return(
                                        <li key={Object.keys(motor)[0]}>
                                            <div style = {{display:"flex"}}>
                                                <label htmlFor={Object.keys(motor)[0]}>{Object.keys(motor)[0]}</label>
                                                <input style={{marginLeft:"5px"}} className="Search_filter_chkbox" type="checkbox" name="motor" id={Object.keys(motor)[0]} readOnly/>
                                            </div>
                                            {
                                                motor[Object.keys(motor)[0]].length > 0
                                                ? 
                                                <ul style={{marginLeft:"15px"}}>
                                                   {/* <label onClick={() => self.handleExpandCPL(index)}>CPLs {self.state.showCpls[index] ? "⯅" : "⯆"}</label>*/}
                                                    <label onClick={() => self.handleExpandCPL(index)}>CPLs {self.state.showCpls[index] ? <span className="glyphicon glyphicon-triangle-top"></span> : <span className="glyphicon glyphicon-triangle-bottom"></span>}</label>
                                                    
                                                    {
                                                        self.state.showCpls[index] 
                                                        ?
                                                        motor[Object.keys(motor)[0]].map(function (cpl) {
                                                            return(<li key={cpl} style = {{display:"flex"}}>
                                                                <label htmlFor={cpl}>{cpl}</label>
                                                                <input style={{marginLeft:"5px"}} className="Search_filter_chkbox" type="checkbox" name="cpl" id={cpl} readOnly />
                                                            </li>)
                                                        })
                                                        :
                                                        null
                                                    }
                                                </ul>
                                                : 
                                                null
                                            }
                                        </li>
                                    )
                                })  
                            }
                        </ul>
                    </div>
                </div>
            )
        }
    }

    handleExpandCPL(index){
        let tempShowCpls = this.state.showCpls;
        
        tempShowCpls[index] = !tempShowCpls[index];
        
        this.setState({showCpls:tempShowCpls},() => {
            $(".fs-scroll").getNiceScroll().resize();
        });
    }

    resetFilters() {
        const selectedCustomFieldOptions = $('.custom-values-checkbox:checked');
        Array.from(selectedCustomFieldOptions).map(function (option, index) {
            $(option).prop('checked', false);
        });

        this.UnSelectAll("marca");
        this.UnSelectAll("categoria");
        this.UnSelectAll("motor");
        this.UnSelectAll("cpl");

        const filters = {
            minimumPrice: null,
            maximumPrice: null,
            customfields: null,
            customValues: null,
        };

        this.setState({
            minPrice: null,
            maxPrice: null,
            selectedPrice: null
        })

        this.props.searchByFilters(filters);
    }

    applyFilters() {

        let minimumPrice = this.state.minPrice;
        let maximumPrice = this.state.maxPrice;

        let arrCategories = this.getCheckedBoxes("categoria");

        let arrCFQueries = [] 

        let arrMarcas = this.getCheckedBoxes("marca");
        let arrMotores = this.getCheckedBoxes("motor");
        let arrCPLs = this.getCheckedBoxes("cpl");

        arrCFQueries = arrMarcas ? 
            this.generateCFQuery(arrCFQueries, this.props.CF_Codes.CF_Marca_Code, arrMarcas) : 
            arrCFQueries;

        arrCFQueries = arrMotores ?
            this.generateCFQuery(arrCFQueries, this.props.CF_Codes.CF_Motor_Code, arrMotores): 
            arrCFQueries;

        arrCFQueries = arrCPLs ?
            this.generateCFQuery(arrCFQueries, this.props.CF_Codes.CF_CPL_Code, arrCPLs): 
            arrCFQueries;

        const filters = {
            minimumPrice: Number(minimumPrice),
            maximumPrice: Number(maximumPrice),
            customValues: {
                arrCFQueries: arrCFQueries,
                arrCategories:arrCategories
            },
            sellerId: this.props.user ? this.props.user.ID : null,
            arrCategories: arrCategories,
            arrCustomFieldQueries: arrCFQueries
        };
        this.props.searchByFilters(filters);
    }

    generateCFQuery(arrQuery_IO, strCFCode_I, arrStrValues){
        
        for (let i = 0; i < arrStrValues.length; i++) {
            const element = arrStrValues[i];
            
            let tempCFQuery = {
                Code: strCFCode_I,
                Operator: "like",
                Value: element
            }
            
            arrQuery_IO.push(tempCFQuery);
        }
        return(arrQuery_IO);
    }

    getCheckedBoxes(chkboxName) {
        var checkboxes = document.getElementsByName(chkboxName);
        var checkboxesChecked = [];
        // loop over them all
        for (var i=0; i<checkboxes.length; i++) {
           // And stick the checked ones onto an array...
           if (checkboxes[i].checked) {
              checkboxesChecked.push(checkboxes[i].id);
           }
        }
        // Return the array if it is non-empty, or null
        return checkboxesChecked.length > 0 ? checkboxesChecked : null;
    }

    UnSelectAll(chkboxName) {
        var items = document.getElementsByName(chkboxName);
        for (var i = 0; i < items.length; i++) {
            if (items[i].type == 'checkbox')
                items[i].checked = false;
        }
    }	

    applyPriceRange(minPrice, maxPrice, index){

        let arrCategories = this.getCheckedBoxes("categoria");

        let arrCFQueries = [] 

        let arrMarcas = this.getCheckedBoxes("marca");
        let arrMotores = this.getCheckedBoxes("motor");
        let arrCPLs = this.getCheckedBoxes("cpl");

        arrCFQueries = arrMarcas ? 
            this.generateCFQuery(arrCFQueries, this.props.CF_Codes.CF_Marca_Code, arrMarcas) : 
            arrCFQueries;

        arrCFQueries = arrMotores ?
            this.generateCFQuery(arrCFQueries, this.props.CF_Codes.CF_Motor_Code, arrMotores): 
            arrCFQueries;

        arrCFQueries = arrCPLs ?
            this.generateCFQuery(arrCFQueries, this.props.CF_Codes.CF_CPL_Code, arrCPLs): 
            arrCFQueries;

        if(maxPrice == null && minPrice == null || !(Number(minPrice) < Number(maxPrice))){
            alert("Por favor introduce un rango valido")
        } else {
            const filters = {
                minimumPrice: minPrice == 0 ? 1 : Number(minPrice),
                maximumPrice: Number(maxPrice),
                customValues: {
                    arrCFQueries: arrCFQueries,
                    arrCategories:arrCategories
                },
                sellerId: this.props.user ? this.props.user.ID : null,
                arrCategories: arrCategories,
                arrCustomFieldQueries: arrCFQueries
            };

            this.setState({
                minPrice: minPrice,
                maxPrice: maxPrice,
                selectedPrice: index
            })
    
            this.props.searchByFilters(filters);
        }
    }

    searchByCategory(categoryId) {
        const self = this;
        let categories = [];

        $('.fixed-sidebar a[data-id="' + categoryId + '"]').each(function (index, item) {
            categories = [];
            var element = $(item);
            var hierarchy = [];
            if (element.parents('.parent-category').length > 0) {
                element.parents('.parent-category').each(function () {
                    hierarchy.push($(this).data('id'));
                });
            }

            if (element.hasClass('root-category')) {
                categories.push({
                    ID: categoryId,
                    Name: element.text(),
                    ParentId: null,
                    ParentName: null,
                    Hierarchy: null
                });
            } else {
                categories.push({
                    ID: categoryId,
                    Name: element.text(),
                    ParentId: element.attr('root-category-id'),
                    ParentName: element.attr('root-category-name'),
                    Hierarchy: hierarchy
                });
            }
        });

        self.props.searchByCategory(categories);
    }

    renderMarca(){
        const self = this;
        let marcas = self.props.categories.find(x => x.ID == process.env.MARCA)
        if(marcas != undefined){
            if(marcas.ChildCategories) {
                return (
                    marcas.ChildCategories.map(function (marca) {
                            return(
                            <li key={marca.Name}>
                                <label htmlFor={marca.Name}>{marca.Name} </label>
                                <input style={{marginLeft:"5px"}} className="Search_filter_chkbox" type="checkbox" value={marca.Name} id={marca.Name} name="marca" readOnly/>
                            </li>
                            )
                    })
                );
            } else {
                return(
                    <div></div>
                );
            }
        }else{
            return(
                <div></div>
            );
        }
    }

    render() {
        const self = this;

        let arrPriceIntervals = this.getPriceIntervals();

        return (
            <div className="fixed-sidebar">
                <div className="fs-content">
                    <div className="fs-scroll" id="search-result-sidebar">
                        <div className="fsc-container">
                            <div className="fsc-field">
                                <span className="Search_title">Escala de precios</span>
                                <div className="Search_filterOption" style={self.state.selectedPrice === 0 ? {textDecoration:"underline", textDecorationColor:"blue"} : null} onClick={()=> self.applyPriceRange(1, 500, 0)}>Menor a $500</div>
                                <div className="Search_filterOption" style={self.state.selectedPrice === 1 ? {textDecoration:"underline", textDecorationColor:"blue"} : null} onClick={()=> self.applyPriceRange(500, 1000, 1)}>Entre $500 a $1,000</div>
                                <div className="Search_filterOption" style={self.state.selectedPrice === 2 ? {textDecoration:"underline", textDecorationColor:"blue"} : null} onClick={()=> self.applyPriceRange(1000, 10000, 2)}>Entre $1,000 a $10,000</div>
                                <div className="Search_filterOption" style={self.state.selectedPrice === 3 ? {textDecoration:"underline", textDecorationColor:"blue"} : null} onClick={()=> self.applyPriceRange(10000, 30000, 3)}>Entre $10,000 a $30,000</div>
                                <div className="Search_filterOption" style={self.state.selectedPrice === 4 ? {textDecoration:"underline", textDecorationColor:"blue"} : null} onClick={()=> self.applyPriceRange(30000, 999999999, 4)}>Mayor a $30,000</div>
                                {
                                    this.props.totalRecords <= 0  || !arrPriceIntervals ?
                                    null
                                    :
                                    <div className="Search_filters">
                                        <div className="Search_filtersField">     
                                            <label className="Search_inputLabel" htmlFor="num_parte">$</label>
                                            <input className="Search_inputField"
                                                type="text"
                                                id="min_range"
                                                placeholder="min"/>
                                        </div>
                                        <div className="Search_filtersField">     
                                            <label className="Search_inputLabel" htmlFor="num_parte">$</label>
                                            <input className="Search_inputField"
                                                type="text"
                                                id="max_range"
                                                placeholder="max"/>
                                        </div>
                                        <div className="Search_priceRange" onClick={() => self.applyPriceRange(document.getElementById("min_range").value, document.getElementById("max_range").value)}>Ir</div>
                                    </div>
                                }
                            </div>
                        </div>
                        <div className="fsc-container">
                            <div className="fsc-categories">
                                <span className="Search_title">Marca</span>
                                <div className="fsc-ul-cat">
                                    <ul>
                                        {self.renderMarca()}
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="fsc-container">
                            <div className="fsc-categories">
                                <span className="Search_title">Categorías</span>
                                <div className="fsc-ul-cat">
                                    <ul>
                                        {self.renderParentCategories()}
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="fsc-container">
                            {self.renderMotorList()}
                        </div>
                        <div className="fsc-container fsc-buttons">
                            <div className="fsc-filter-action">
                                <div className="btn-gray" style={{padding: "7px 20px"}} onClick={() => self.resetFilters()}>Restablecer</div>
                                <div className="btn-blue" onClick={() => self.applyFilters()}>Aplicar</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="fs-btn-slide">
                    <span>Filtros</span>
                    <span>
                        <i className="fa fa-angle-down" />
                        <i className="fa fa-angle-up" />
                    </span>
                </div>
            </div>
        );
    }
}

module.exports = SearchFilterComponent;
